import { Box, Button } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import TextField from 'modules/core/components/TextField'
import i18n from 'modules/core/lib/i18n'

export interface Option {
  parent_id?: string
  id?: string
  hidden?: boolean
  label: string
  value: string | number
}

interface Props {
  label: string
  options: Option[]
  creatable?: boolean
  editable?: boolean
  deletable?: boolean
  onChange?: (options: Option[]) => void
}

const Options = ({ label, options, creatable, editable, deletable, onChange }: Props) => {
  const onCreate = () => {
    onChange?.([...options, { label: '', value: '' }])
  }

  const onEdit = (edited: Option, label: string) => {
    onChange?.(options.map((option) => (option === edited ? { ...option, label } : option)))
  }

  const onDelete = (deleted: Option) => {
    onChange?.(options.filter((option) => option !== deleted))
  }

  return (
    <>
      {options.map((option, index) => (
        <Box paddingY="s8" flexDirection="row" gap="s8" alignItems="center" key={index}>
          <TextField
            mandatory
            label={`${label} ${index + 1}`}
            value={option.label}
            readonly={!editable && Boolean(option.value)}
            onChange={(label) => onEdit(option, label)}
          />
          {deletable && (
            <Box paddingTop="s24">
              <Button type="secondary" onClick={() => onDelete(option)} iconName="delete" />
            </Box>
          )}
        </Box>
      ))}

      {creatable && (
        <Box alignItems="flexStart" paddingTop="s8">
          <Button type="secondary" onClick={onCreate} iconName="add">
            {i18n.t('expenses.settings.customization.helpers.add_option')}
          </Button>
        </Box>
      )}
    </>
  )
}

export default observer(Options)
